import React, {PropsWithChildren, ReactNode} from "react";

import {elevation} from "@pg-design/elevation";
import {backgroundColor, borderRadius, p, pt} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

interface IProps {
    children: ReactNode;
    as?: React.ElementType;
    className?: string;
}

export const SiteMapBox = (props: IProps) => {
    const CustomTag = props.as || "div";

    return (
        <CustomTag css={[elevation(), borderRadius(), backgroundColor("#fff"), p(2)]} className={props.className}>
            {props.children}
        </CustomTag>
    );
};

SiteMapBox.Header = (props: PropsWithChildren<{as?: Parameters<typeof Text>[0]["as"]; className?: string}>) => {
    return (
        <Text variant="headline_5" as={props.as || "div"} css={[pt(2)]} className={props.className}>
            {props.children}
        </Text>
    );
};
import React, {PropsWithChildren, ReactNode} from "react";

import {elevation} from "@pg-design/elevation";
import {backgroundColor, borderRadius, p, pt} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

interface IProps {
    children: ReactNode;
    as?: React.ElementType;
    className?: string;
}

export const SiteMapBox = (props: IProps) => {
    const CustomTag = props.as || "div";

    return (
        <CustomTag css={[elevation(), borderRadius(), backgroundColor("#fff"), p(2)]} className={props.className}>
            {props.children}
        </CustomTag>
    );
};

SiteMapBox.Header = (props: PropsWithChildren<{as?: Parameters<typeof Text>[0]["as"]; className?: string}>) => {
    return (
        <Text variant="headline_5" as={props.as || "div"} css={[pt(2)]} className={props.className}>
            {props.children}
        </Text>
    );
};
